import React, { useState, useEffect, useContext } from "react";
import "./Define.css";
import {
   Grid,
   Box,
   Chip,
   TextField,
   Typography,
   MenuItem,
   Button,
   Divider,
   Backdrop,
   CircularProgress,
   Dialog,
   DialogTitle,
   DialogContent,
   DialogActions,
   IconButton,
   Paper,
   Stack,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector, useDispatch } from "react-redux";
import DefineQuotaChart from "./DefineQuotaChart";
import DefineQuotaBreakdown from "./DefineQuotaBreakdown";
import SharedComponent from "./SharedComponent";
import ExportData from "./ExportData";
import {
   SaveOutlined,
   DrawRounded,
   TaskAltOutlined,
   DownloadOutlined,
   UploadOutlined,
   Close,
   UploadFile,
   TaskAltRounded,
   SpeakerNotesOutlined,
   DoNotDisturbOutlined,
} from "@mui/icons-material";
import Dropzone from "react-dropzone";
import Draggable from "react-draggable";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Comments from "./comments";
import FileAttach from "./FileAttach";
import Attachments from "./Attachments";

import {
   GetUserCountries,
   GetScenarioforQuotaDefinition,
   GetQuotaPeriods,
   GetQuotaDetails,
   GetQuotaChartData,
   setSelectedCountry,
   setSelectedScenario,
   setSelectedPeriod,
   setForecast,
   setQuotaCopy,
   setTimeDepletion,
   GetWeeklyDepletion,
   setSelectProduct,
   setRounder,
   setApplyRounder,
   setSafetyMargin,
   setBufferAdjustment,
   setApplySafetyMargin,
   GetSKUOrPGByScenario,
   setTotalValues,
   setWeekPercent,
   setWeekPercentDepletion,
   GetWeeklyDepletionValues,
   setLoadData,
   reset,
   ExportExcel,
   ImportExcel,
   setQuotaObject,
   SaveQuota,
   Upload,
   SubmitQuota,
   DownloadFile,
   setState,
   setApplyBufferAdjustment,
} from "./defineSlice";
import ViewSearchRefresh from "./ViewSearchRefresh";
import DefineQuotaTable from "./DefineQuotaTable";
import ChartTableToggle from "./ChartTableToggle";
import { formatNumber, removeComma } from "./defineUtils";
import ExportDataModal from "./ExportDataModal";

function PaperComponent(props) {
   return (
      <Draggable
         handle="#draggable-dialog-title"
         cancel={'[class*="MuiDialogContent-root"]'}
      >
         <Paper {...props} />
      </Draggable>
   );
}

const criticalities = [
   { key: 0, value: "None" },
   { key: 1, value: "Low" },
   { key: 2, value: "Medium" },
   { key: 3, value: "High" },
   { key: 4, value: "Severe" },
   { key: 5, value: "Other" },
];

function DefineQuota() {
   const autherization = localStorage.getItem("data");
   const data = JSON.parse(autherization);
   let setAccess = true;
   if (data?.restrictedAccess == 0) setAccess = true;
   else setAccess = false;
   const isRestrictedAccess = setAccess;
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const {
      isLoading,
      countries,
      selectedCountry,
      scenarioList,
      selectedScenario,
      quotaPeriods,
      weeklyDepletionList,
      selectedPeriod,
      selectedQuota,
      loadQuotaDetails,
      loadQuotaChart,
      selectedDepletion,
      listProduct,
      selectedProduct,
      TotalAdjustment,
      TotalSafetyMargin,
      TotalUnusedQuota,
      TotalQuota,
      rounder,
      initialForecast,
      revisedQuota,
      onSubmitDisabled,
      forecastType,
      commonSafetyMargin,
      bufferAdjustment,
      quotaCopy,
      isNavigate,
      filter_customerTypes,
      filter_customerTrustLevels,
      gridData
   } = define;

   const [open, setOpen] = useState(false);
   const [selectedFiles, setSelectedFiles] = useState(undefined);
   const [currentFile, setCurrentFile] = useState(undefined);

   useEffect(() => {
      if (!isNavigate) {
         dispatch(reset("onRefresh"));
         dispatch(GetUserCountries({ method: "Get" }));
      } else {
         dispatch(reset("onRefresh"));
         dispatch(setState("isNavigate", false));
      }
   }, []);

   const handleCountryChange = (e) => {
      let v = e.target.value;
      dispatch(setState("selectedRows", []));
      dispatch(setSelectedCountry(v));
      dispatch(reset("countryChange"));
      dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: v }));
      // dispatch(GetScenarioforQuotaDefinition({ method: "GET", countryId: id })).then(() => {
      //     dispatch(GetQuotaPeriods({ method: "GET"}));
      // });
   };

   const handleScenarioChange = (e) => {
      let v = e.target.value;
      dispatch(setState("selectedRows", []));
      dispatch(setSelectedScenario(v));
      dispatch(reset("scenarioChange"));
      dispatch(GetQuotaPeriods({ method: "GET", scenarioID: v }));
      dispatch(GetWeeklyDepletion({ method: "GET" }));
   };

   const handlePeriodChange = (e) => {
      dispatch(reset("onPeriodChange"));
      let v = e.target.value;
      dispatch(setState("selectedRows", []));
      dispatch(setSelectedPeriod(v));
      dispatch(GetWeeklyDepletion({ method: "GET" }));
   };

   const handleRetrive = () => {
      dispatch(setState("gridDataChanged", false));
      if (
         selectedCountry.countryID === undefined ||
         selectedCountry.countryID === null
      ) {
         showMessage("Please select a country", "info");
      } else if (
         selectedScenario.scenarioID === undefined ||
         selectedScenario.scenarioID === null
      ) {
         showMessage("Please select a scenario", "info");
      } else if (
         selectedPeriod.startDate === undefined ||
         selectedPeriod.startDate === null
      ) {
         showMessage("Please select a validity period", "info");
      } else {
         dispatch(setState("filter_customerTypes", []));
         dispatch(setState("filter_customerTrustLevels", []));
         dispatch(setState("selectedRows", []));

         dispatch(reset("onRetriveClick"));
         let queryParams =
            "scenarioId=" +
            selectedScenario.scenarioID +
            "&startDate=" +
            selectedPeriod.startDate +
            "&endDate=" +
            selectedPeriod.endDate +
            "&countryId=" +
            selectedCountry.countryID +
            "&breakdown=" +
            false;

         dispatch(
            GetQuotaDetails({ method: "GET", queryParams: queryParams })
         ).then((response) => {
            dispatch(setTotalValues());
            dispatch(GetSKUOrPGByScenario({ method: "GET" })).then(() => {
               if (
                  selectedDepletion.key !== "None" ||
                  response.previousPeriodDepletionModel !== "None"
               ) {
                  dispatch(GetWeeklyDepletionValues({ method: "GET" })).then(
                     () => {
                        dispatch(setTotalValues());
                        dispatch(setLoadData());
                        dispatch(GetQuotaChartData({ method: "POST" }));
                     }
                  );
               } else {
                  dispatch(setWeekPercent());
                  dispatch(setLoadData());
                  dispatch(GetQuotaChartData({ method: "POST" }));
               }
            });
         });
      }
   };
   const showMessage = (message, severity) => {
      dispatch(setState("isFailed_Info", message));
      dispatch(setState("isFailed", true));
   };
   const onSubmit = (values) => {};

   const handleForecastType = () => {};

   const handleQuotaCopy = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setQuotaCopy(v));
   };

   const handleForecast = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setForecast(v));
   };

   const handleTimeDepletion = (e) => {
      let v = e.target.value;
      dispatch(setTimeDepletion(v));
      //dispatch(GetWeeklyDepletionValues({ method: "GET" }));
      handleAllocate();
   };
   const handleAllocate = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(reset("onAllocateClick"));
      let queryParams =
         "scenarioId=" +
         selectedScenario.scenarioID +
         "&startDate=" +
         selectedPeriod.startDate +
         "&endDate=" +
         selectedPeriod.endDate +
         "&countryId=" +
         selectedCountry.countryID +
         "&breakdown=" +
         true;
      dispatch(
         GetQuotaDetails({ method: "GET", queryParams: queryParams })
      ).then(() => {
         // if (selectedDepletion.key !== "None") {
         console.log("Define_selectedDepletion", selectedDepletion);
         dispatch(GetWeeklyDepletionValues({ method: "GET" })).then(() => {
            dispatch(setWeekPercentDepletion());
            dispatch(setLoadData());
            dispatch(GetQuotaChartData({ method: "POST" }));
         });
         // this.showWeekColumns = true;
         //} else {
         // this.showWeekColumns = false;
         //    dispatch(setWeekPercentDepletion());
         //    dispatch(setLoadData());
         //    dispatch(GetQuotaChartData({ method: "POST" }));
         // }
      });
   };

   const handleSelectProduct = (e) => {
      let v = e.target.value;
      dispatch(reset("onProductChange"));
      dispatch(setSelectProduct(v));
      dispatch(setLoadData());
      dispatch(GetQuotaChartData({ method: "POST" }));
      let val = gridData?.filter((item) =>{
         return(
         (filter_customerTypes.length === 0 || filter_customerTypes.some(type => item.type.toLowerCase().includes(type.toLowerCase()))) &&
         (filter_customerTrustLevels.length === 0 || filter_customerTrustLevels.some(level => item.customerTrustLevel.toLowerCase().includes(level.toLowerCase()))) &&
         (v === 0 || v === undefined || item.skuid === v || item.productGroupID === v)
         );});
      dispatch(setState("gridDataFiltered", val));
      // dispatch(GetQuotaChartData({ method: "POST" }));
   };

   const handleRounder = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setRounder(v));
   };
   const handleSafetyMargin = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setSafetyMargin(v));
   };
   const handleBufferAdjustment = (e) => {
      let v = e.target.value;
      v = removeComma(v);
      dispatch(setBufferAdjustment(v));
   };

   const applyRounder = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(setState("isLoading", true));
      let timeout = setTimeout(() => {
      dispatch(reset("onApplyRounder"));
      dispatch(setApplySafetyMargin());
      //dispatch(setApplyBufferAdjustment());
      dispatch(setApplyRounder());
      dispatch(setTotalValues());
      dispatch(setLoadData());
      dispatch(GetQuotaChartData({ method: "POST" }));
      },10);
      return () => clearTimeout(timeout);
   };

   const handleDownloadQuota = () => {
      dispatch(setQuotaObject({ method: "excelDownload" }));
      dispatch(ExportExcel({ method: "POST" }));
   };

   const handleUploadQuota = () => {
      setOpen(true);
   };

   const handleClose = () => {
      setSelectedFiles("");
      setOpen(false);
   };

   const onDrop = (files) => {
      console.log("onDrop files", files);
      if (files.length > 0) {
         setSelectedFiles(files);
      }
   };

   const handleProcess = () => {
      dispatch(setState("gridDataChanged", true));
      dispatch(reset("onImportExcel"));
      let currentFile = selectedFiles[0];
      setCurrentFile(currentFile);
      setSelectedFiles("");
      let formData = new FormData();
      formData.append("files", currentFile);
      dispatch(ImportExcel({ method: "POST", body: formData })).then(() => {
         dispatch(setTotalValues());
         dispatch(setLoadData());
         dispatch(GetQuotaChartData({ method: "POST" }));
      });
      setOpen(false);
   };

   const handleSaveQuota = () => {
      dispatch(setState("gridDataChanged", false));
      dispatch(Upload({ method: "POST" })).then(() => {
         dispatch(setQuotaObject({ method: "saveQuota" }));
         dispatch(SaveQuota({ method: "POST" })).then((response) => {
            if (response.payload !== "error") {
               dispatch(reset("onAllocateClick"));
               dispatch(setLoadData());
               dispatch(GetQuotaChartData({ method: "POST" }));
            }
         });
         dispatch(setState("saveOrSubmitError", 0));
      });
   };

   const handleSubmitQuota = () => {
      dispatch(setState("gridDataChanged", false));
      dispatch(Upload({ method: "POST" })).then(() => {
         dispatch(setQuotaObject({ method: "submitQuota" }));
         dispatch(SubmitQuota({ method: "POST" })).then((response) => {
            if (response.payload !== "error") {
               handleRetrive();
            }
         });
         dispatch(setState("saveOrSubmitError", 0));
      });
   };

   const handleDownloadFile = (filepath) => {
      dispatch(DownloadFile(filepath));
   };

   return (
      <Box>
         <Typography variant="subtitle1" my={2}>
            Search for Scenario
         </Typography>
         {/* <form onSubmit={handleSubmit(onSubmit)}> */}
         {/* <Box className="scenario-search"> */}
         <Grid
            container
            columns={12}
            justifyContent="flex-start"
            alignItems="center"
            spacing={3}
            pb={1}
         >
            <Grid item xs={6} sm={6} md={2.9} lg={2.9}>
               <TextField
                  variant="outlined"
                  label="Country"
                  select={countries.length > 0 ? true : false}
                  value={countries.length > 0 ? selectedCountry.countryID : " "}
                  onChange={handleCountryChange}
                  fullWidth
                  size="small"
                  // disabled={countries.length > 0 ? false : true}
                  // {...register("country", {
                  //     required: "Please select a country",
                  // })}
                  // error={Boolean(errors.country)}
                  // helperText={errors ?.country ?.message}
               >
                  {countries.length > 0
                     ? countries.map((country, index) => {
                          return (
                             <MenuItem
                                key={country.countryID}
                                value={country.countryID}
                             >
                                {country.countryName}
                             </MenuItem>
                          );
                       })
                     : null}
               </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
               <TextField
                  variant="outlined"
                  label="Scenario"
                  select={scenarioList.length > 0 ? true : false}
                  value={
                     scenarioList.length > 0 ? selectedScenario.scenarioID : ""
                  }
                  onChange={handleScenarioChange}
                  size="small"
                  fullWidth
                  disabled={scenarioList.length > 0 ? false : true}
                  // required
                  // {...register("scenario", {
                  //     required: "Please select a scenario",
                  // })}
                  // error={Boolean(errors.scenario)}
                  // helperText={errors ?.scenario ?.message}
               >
                  {scenarioList.length > 0
                     ? scenarioList.map((scenario, index) => {
                          return (
                             <MenuItem
                                key={scenario.scenarioID}
                                value={scenario.scenarioID}
                             >
                                {scenario.scenarioName}
                             </MenuItem>
                          );
                       })
                     : null}
               </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={4}>
               <TextField
                  variant="outlined"
                  label="Validity Period"
                  select={quotaPeriods.length > 0 ? true : false}
                  value={
                     quotaPeriods.length > 0 ? selectedPeriod.displayDate : ""
                  }
                  onChange={handlePeriodChange}
                  size="small"
                  fullWidth
                  disabled={quotaPeriods.length > 0 ? false : true}
                  // {...register("currentPeriod", {
                  //     required: "Please select validity period.",
                  // })}
                  // error={Boolean(errors.currentPeriod)}
                  // helperText={errors ?.currentPeriod ?.message}
               >
                  {quotaPeriods.length > 0
                     ? quotaPeriods.map((quota, index) => {
                          return (
                             <MenuItem
                                key={quota.displayDate}
                                value={quota.displayDate}
                             >
                                {quota.displayDate}
                             </MenuItem>
                          );
                       })
                     : null}
               </TextField>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={1}>
               <Box justifyContent="center" display="flex">
                  <Button
                     sx={{
                        bgcolor: "blue.main",
                        color: "white.main",
                        fontWeight: "700",
                     }}
                     startIcon={<SearchIcon />}
                     variant="contained"
                     onClick={handleRetrive}
                     size="large"
                  >
                     Retrieve
                  </Button>
               </Box>
            </Grid>
         </Grid>
         {loadQuotaDetails && (
            <>
               <Divider sx={{ margin: "16px 0" }} />
               <Typography variant="subtitle1">Define Quota</Typography>
               <Grid
                  container
                  columns={12}
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
               >
                  <Grid item xs={12} sm={6} md={8} lg={9}>
                     <Typography variant="subtitle1">
                        {`${selectedScenario?.scenarioName} (Criticality: ${
                           criticalities.find(
                              (item) =>
                                 item.key === selectedScenario.criticalityId
                           ).value
                        })`}
                     </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3} md={2} lg={2}>
                     <Typography variant="subtitle2">
                        Quota status
                        <Chip
                           icon={
                              (selectedQuota?.quotaStatus === "Approved" && (
                                 <TaskAltRounded />
                              )) ||
                              (selectedQuota?.quotaStatus ===
                                 "Locally Approved" && <TaskAltRounded />) ||
                              (selectedQuota?.quotaStatus === "Draft" && (
                                 <DrawRounded />
                              )) ||
                              (selectedQuota?.quotaStatus === "Submitted" && (
                                 <DrawRounded />
                              )) ||
                              (selectedQuota?.quotaStatus === "Rejected" && (
                                 <DrawRounded />
                              )) ||
                              (selectedQuota?.quotaStatus === "Invalid" && (
                                 <DrawRounded />
                              )) ||
                              ((selectedQuota?.quotaStatus === null ||
                                 selectedQuota?.quotaStatus === " ") && (
                                 <DoNotDisturbOutlined />
                              ))
                           }
                           label={
                              selectedQuota?.quotaStatus === null ||
                              selectedQuota?.quotaStatus === " "
                                 ? "N/A"
                                 : selectedQuota?.quotaStatus
                           }
                           color={
                              (selectedQuota?.quotaStatus === "Approved" &&
                                 "success") ||
                              (selectedQuota?.quotaStatus ===
                                 "Locally Approved" &&
                                 "success") ||
                              (selectedQuota?.quotaStatus === "Draft" &&
                                 "info") ||
                              (selectedQuota?.quotaStatus === "Submitted" &&
                                 "info") ||
                              (selectedQuota?.quotaStatus === "Rejected" &&
                                 "error") ||
                              (selectedQuota?.quotaStatus === "Invalid" &&
                                 "error") ||
                              ((selectedQuota?.quotaStatus === null ||
                                 selectedQuota?.quotaStatus === " ") &&
                                 "error")
                           }
                           variant="outlined"
                           size="small"
                           sx={{ ml: 1, p: 1 }}
                        />
                     </Typography>
                  </Grid>
                  <Grid item xs={12} sm={3} md={2} lg={1}>
                     <ExportData />
                  </Grid>
               </Grid>

               <ExportDataModal/>

               <Divider sx={{ margin: "16px 0" }} />
               <Grid
                  container
                  columns={10}
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  pb={1}
               >
                  <Grid item xs={6} sm={2} md={2} lg={2.25}>
                     <TextField
                        variant="outlined"
                        readOnly={true}
                        label="Forecast Type"
                        value={forecastType}
                        //select={countries.length > 0 ? true : false}
                        //value={countries.length > 0 ? selectedCountry.countryID : " "}
                        onChange={handleForecastType}
                        fullWidth
                        size="small"
                        //disabled={countries.length > 0 ? false : true}
                     >
                        {/* {countries.length > 0 ? (
                                countries.map((country, index) => {
                                    return (
                                        <MenuItem key={country.countryID} value={country.countryID}>
                                            {country.countryName}
                                        </MenuItem>
                                    )
                                })) : null
                            } */}
                     </TextField>
                  </Grid>
                  <Grid item xs={6} sm={2} md={2} lg={2.25}>
                     <TextField
                        disabled={true}
                        variant="outlined"
                        label="Forecast"
                        readOnly={true}
                        value={initialForecast?.toLocaleString()}
                        onChange={handleForecast}
                        size="small"
                        fullWidth
                     ></TextField>
                  </Grid>
                  <Grid item xs={6} sm={2} md={2} lg={2.25}>
                     <TextField
                        variant="outlined"
                        label="Quota Copy"
                        value={selectedQuota?.quotaCopy?.toLocaleString()}
                        onChange={handleQuotaCopy}
                        size="small"
                        fullWidth
                     ></TextField>
                  </Grid>
                  <Grid item xs={6} sm={2} md={2} lg={2.25}>
                     <TextField
                        sx={{
                           display:
                              selectedScenario.periodType === "Monthly"
                                 ? "block"
                                 : "none",
                        }}
                        variant="outlined"
                        label="Time Depletion"
                        select={weeklyDepletionList.length > 0 ? true : false}
                        value={
                           weeklyDepletionList.length > 0
                              ? selectedDepletion?.value
                              : ""
                        }
                        onChange={handleTimeDepletion}
                        size="small"
                        fullWidth
                        disabled={weeklyDepletionList.length > 0 ? false : true}
                     >
                        {weeklyDepletionList.length > 0
                           ? weeklyDepletionList.map((item, index) => {
                                return (
                                   <MenuItem key={item.key} value={item.value}>
                                      {item.value}
                                   </MenuItem>
                                );
                             })
                           : null}
                     </TextField>
                  </Grid>
                  <Grid item xs={12} sm={2} md={2} lg={1}>
                     <Box justifyContent="center" display="flex">
                        <Button
                           sx={{
                              bgcolor: "blue.main",
                              color: "white.main",
                              fontWeight: "700",
                           }}
                           variant="contained"
                           size="large"
                           disabled={!isRestrictedAccess}
                           onClick={handleAllocate}
                        >
                           Allocate
                        </Button>
                     </Box>
                  </Grid>
               </Grid>
               <Divider sx={{ margin: "16px 0", my: 2 }} />
               <Grid
                  container
                  columns={10}
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  pb={1}
               >
                  <Grid item xs={6} sm={2} md={2} lg={2.25}>
                     <TextField
                        variant="outlined"
                        label="Select Product"
                        select={listProduct.length > 0 ? true : false}
                        value={
                           listProduct.length > 0
                              ? selectedProduct.packGroupOrSKUID
                              : 0
                        }
                        onChange={handleSelectProduct}
                        size="small"
                        fullWidth
                        disabled={listProduct.length > 0 ? false : true}
                     >
                        {listProduct.length > 0
                           ? listProduct.map((item, index) => {
                                return (
                                   <MenuItem
                                      key={item.key}
                                      value={item.packGroupOrSKUID}
                                   >
                                      {item.packGroupOrSKUName}
                                   </MenuItem>
                                );
                             })
                           : null}
                     </TextField>
                  </Grid>
                  <Grid item xs={3} sm={2} md={2} lg={2.25}>
                     <TextField
                        variant="outlined"
                        label="Safety Margin"
                        value={commonSafetyMargin?.toLocaleString()}
                        onChange={handleSafetyMargin}
                        size="small"
                        fullWidth
                     ></TextField>
                  </Grid>
                  <Grid item xs={3} sm={2} md={2} lg={2.25}>
                     <TextField
                        variant="outlined"
                        label="Rounder"
                        value={rounder?.toLocaleString()}
                        onChange={handleRounder}
                        size="small"
                        fullWidth
                     ></TextField>
                  </Grid>
                  <Grid item xs={3} sm={2} md={2} lg={2.25}>
                     <TextField
                        variant="outlined"
                        label="Buffer Adjustment"
                        value={bufferAdjustment?.toLocaleString()}
                        onChange={handleBufferAdjustment}
                        size="small"
                        fullWidth
                     ></TextField>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2} lg={1}>
                     <Box justifyContent="center" display="flex">
                        <Button
                           sx={{
                              bgcolor: "blue.main",
                              color: "white.main",
                              fontWeight: "700",
                           }}
                           variant="contained"
                           disabled={!isRestrictedAccess}
                           onClick={applyRounder}
                           size="large"
                        >
                           Apply
                        </Button>
                     </Box>
                  </Grid>
               </Grid>
               <Grid
                  container
                  columns={10}
                  justifyContent="space-between"
                  alignItems="center"
                  spacing={2}
                  pb={1}
               >
                  <Grid item sx={{ my: 3 }} sm={2} md={2} lg={2.25}>
                     <TextField
                        variant="outlined"
                        label="Revised Quota"
                        readOnly={true}
                        value={revisedQuota?.toLocaleString()}
                        size="small"
                        fullWidth
                     ></TextField>
                  </Grid>
                  <Grid item xs={7} sm={7} md={7} lg={7.75}>
                     <Box className="quota_details_layout">
                        <Grid
                           container
                           columns={12}
                           justifyContent="space-around"
                           columnGap={2}
                           p={1}
                        >
                           <Grid item xs={2}>
                              <Typography className="quota_numbers">
                                 {TotalAdjustment?.toLocaleString()}
                                 <Typography className="quota_labels">
                                    Total Adjustments
                                 </Typography>
                              </Typography>
                           </Grid>
                           <Grid item xs={2}>
                              <Typography className="quota_numbers">
                                 {TotalSafetyMargin?.toLocaleString()}
                                 <Typography className="quota_labels">
                                    Total Safety Margin
                                 </Typography>
                              </Typography>
                           </Grid>
                           <Grid item xs={2}>
                              <Typography className="quota_numbers">
                                 {TotalUnusedQuota?.toLocaleString()}
                                 <Typography className="quota_labels">
                                    Total Unused Quota
                                 </Typography>
                              </Typography>
                           </Grid>
                           <Grid item xs={2}>
                              <Typography className="quota_numbers">
                                 {TotalQuota?.toLocaleString()}
                                 <Typography className="quota_labels">
                                    Total Quota
                                 </Typography>
                              </Typography>
                           </Grid>
                        </Grid>
                     </Box>
                  </Grid>
               </Grid>
               <Divider sx={{ margin: "16px 0" }} />
               {loadQuotaChart && <ChartTableToggle />}
               {loadQuotaChart && <DefineQuotaChart />}
               {loadQuotaChart && <DefineQuotaTable />}
            </>
         )}
         {loadQuotaDetails && (
            <>
               <Stack direction="row" alignItems="center" gap={2}>
                  <Typography
                     className="compHeading"
                     sx={{
                        color: "#007DC3",
                        fontWeight: "bold",
                        mt: 3,
                        width: "100%",
                     }}
                  >
                     <DownloadOutlined
                        sx={{ mt: 0, transform: "translate(0px, 8px)" }}
                        color="info"
                     />{" "}
                     Customer Breakdown
                  </Typography>
               </Stack>
            </>
         )}
         <Box sx={!loadQuotaDetails && { display: "none" }}>
            <ViewSearchRefresh />
            <DefineQuotaBreakdown />
         </Box>

         {loadQuotaDetails && (
            <>
               {selectedQuota?.listQuotaFiles?.length > 0 && (
                  <Stack direction="row" alignItems="center" gap={2}>
                     <SpeakerNotesOutlined color="info" sx={{ mt: 4 }} />
                     <Typography
                        sx={{ color: "#007DC3", fontWeight: "bold", mt: 4 }}
                     >
                        Attachments
                     </Typography>
                  </Stack>
               )}
               <Table>
                  <TableBody>
                     {selectedQuota?.listQuotaFiles.map((row) => {
                        return (
                           <TableRow className="tableRow" key={row?._id}>
                              <TableCell
                                 className="tableCell"
                                 sx={{ flexGrow: 1 }}
                              >
                                 {row.filePath}
                              </TableCell>
                              <TableCell className="tableCell">
                                 <Button
                                    variant="outlined"
                                    startIcon={<DownloadOutlined />}
                                    size="small"
                                    onClick={() =>
                                       handleDownloadFile(row.filePath)
                                    }
                                 >
                                    Download
                                 </Button>{" "}
                              </TableCell>
                           </TableRow>
                        );
                     })}
                  </TableBody>
               </Table>
               <FileAttach />
               <Attachments />
               <Comments />
               <Grid container columns={12} justifyContent="flex-start" my={4}>
                  <Grid item xs={6} sm={2} md={2} lg={1.8}>
                     <Button
                        sx={{
                           bgcolor: "blue.main",
                           color: "white.main",
                           fontWeight: "700",
                        }}
                        variant="contained"
                        startIcon={<DownloadOutlined />}
                        onClick={handleDownloadQuota}
                     >
                        Download Quota
                     </Button>
                  </Grid>
                  <Grid item xs={6} sm={2} md={2} lg={1.8}>
                     <Button
                        sx={{
                           bgcolor: "blue.main",
                           color: "white.main",
                           fontWeight: "700",
                        }}
                        variant="contained"
                        disabled={!isRestrictedAccess}
                        startIcon={<UploadOutlined />}
                        onClick={handleUploadQuota}
                     >
                        Upload Quota
                     </Button>
                  </Grid>
               </Grid>
               <Box my={2} />
               <Grid
                  container
                  columns={12}
                  spacing={1}
                  justifyContent="flex-end"
                  alignItems="right"
                  my={2}
               >
                  <Grid item xs={6} sm={2} md={2} lg={1.4}>
                     <Button
                        sx={{
                           bgcolor: "blue.main",
                           color: "white.main",
                           fontWeight: "700",
                        }}
                        variant="contained"
                        startIcon={<SaveOutlined />}
                        onClick={handleSaveQuota}
                        disabled={onSubmitDisabled || !isRestrictedAccess}
                     >
                        Save Quota
                     </Button>
                  </Grid>
                  <Grid item xs={6} sm={2} md={2} lg={1.5}>
                     <Button
                        sx={{
                           bgcolor: "blue.main",
                           color: "white.main",
                           fontWeight: "700",
                        }}
                        variant="contained"
                        startIcon={<TaskAltOutlined />}
                        onClick={handleSubmitQuota}
                        disabled={onSubmitDisabled || !isRestrictedAccess}
                     >
                        Submit Quota
                     </Button>
                  </Grid>
               </Grid>
               <Box my={2} />
            </>
         )}

         <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
         >
            <CircularProgress />
         </Backdrop>
         <SharedComponent />
         <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            maxWidth="sm"
            fullWidth
         >
            <DialogTitle style={{ cursor: "move" }}>
               Upload Quota
               <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                     position: "absolute",
                     right: 8,
                     top: 8,
                     color: (theme) => theme.palette.grey[500],
                  }}
               >
                  <Close />
               </IconButton>
            </DialogTitle>
            <DialogContent
               sx={{
                  paddingTop: "5px !important",
                  paddingBottom: "12px !important",
               }}
            >
               <div className="dropzone-container">
                  <Dropzone
                     onDrop={onDrop}
                     multiple={false}
                     // accept = {["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]}
                  >
                     {({ getRootProps, getInputProps }) => (
                        <section className="dropzone">
                           <div {...getRootProps({})}>
                              <input {...getInputProps()} />
                              {selectedFiles && selectedFiles[0].name ? (
                                 <div className="selected-file">
                                    {selectedFiles && selectedFiles[0].name}
                                 </div>
                              ) : (
                                 <div>
                                    <UploadFile fontSize="medium" />
                                    <div>Drag file here or click to browse</div>
                                 </div>
                              )}
                           </div>
                        </section>
                     )}
                  </Dropzone>
               </div>
            </DialogContent>
            <DialogActions sx={{ padding: "12px 24px !important" }}>
               <Button onClick={handleClose}>Cancel</Button>
               <Button
                  variant="contained"
                  onClick={handleProcess}
                  type="submit"
               >
                  Process
               </Button>
            </DialogActions>
         </Dialog>
      </Box>
      /* </form> */
   );
}

export default DefineQuota;
